<!-- 进度条 -->
<template>
  <div>
    <div class="progress">
      <div class="progressHeader center">
        <span :class="status =='1' ?'iconfont icon11 spanblue':'iconfont icon1'">
        </span>
        <span>基本信息</span>
      </div>
      <div class="progressLine center">
        <span></span>
      </div>
      <div class="progressHeader center">
        <span :class="status =='2' ?'iconfont icon21 spanblue':'iconfont icon2'">
        </span>
        <span>支付信息</span>
      </div>
      <div class="progressLine center">
        <span></span>
      </div>
      <div class="progressHeader center">
        <span :class="status =='3' ?'iconfont icon31 spanblue':'iconfont icon3'">
        </span>
        <span>商品详情</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    status: {
      type: String,
      default: "1"
    }
  }
}
</script>
<style lang= "scss" scoped>
/* 进度条 */
.progress {
  /* width:calc(82vw - 34px); */
  width: 100%;
  height: 120px;
  line-height: 120px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      display: block;
    }
  }
  .progressHeader {
    span {
      font-size: 16px;
      padding: 0 8px;
    }
    span:nth-child(1) {
      font-size: 30px;
    }
    .spanblue {
      color: #409EFF!important;
    }
  }
  .progressLine {
    width: 150px;
    height: 130px;
    span {
      width: 100%;
      height: 1px;
      background: #ccc;
    }
  }
}
</style>
